import { render, staticRenderFns } from "./RegisterQualityPerProcess.vue?vue&type=template&id=479a4bf7&"
import script from "./RegisterQualityPerProcess.vue?vue&type=script&lang=js&"
export * from "./RegisterQualityPerProcess.vue?vue&type=script&lang=js&"
import style0 from "./RegisterQualityPerProcess.vue?vue&type=style&index=0&id=479a4bf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports